import styled from "styled-components";

export const TargetBox = styled.div`
  width: 160px;
  height: 75px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 10px 15px;
  gap: 10px;
  border-radius: 10px;
  background-color: ${({ isTargetAchieved, hasMinTarget, theme }) =>
    hasMinTarget
      ? isTargetAchieved
        ? theme.colors.dataViz.targetAchievedBoxBgColor
        : theme.colors.dataViz.targetMissedBoxBgColor
      : "none"};
`;

export const TargetTitle = styled.div`
  color: ${({ isTargetAchieved, theme }) =>
    isTargetAchieved
      ? theme.colors.dataViz.targetAchievedTextColor
      : theme.colors.dataViz.targetMissedTextColor};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const TargetValue = styled.div`
  color: black;
  font-weight: 600;
  font-size: 18px;
  font-style: normal;
  line-height: normal;
`;
